import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Avatar,
  Typography,
  Box,
} from "@mui/material";
import { assetIcons, CurrencyIcon } from "../../../constants/assets";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import {
  StyledTableContainer,
  StyledTableRow,
} from "../table-styling/table-styling";

// Custom styled components

const UserCell = ({ avatar, username }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Avatar
      src={avatar || "/placeholder.svg?height=40&width=40"}
      sx={{
        width: 34,
        height: 34,
        border: `2px solid ${darkColors.buttonTop}`,
        mr: 0.5,
      }}
    />
    <Typography
      sx={{ color: "#fff", fontSize: fontSizes.heading3, fontWeight: 600 }}
    >
      {username || "Guest User"}
    </Typography>
  </Box>
);

export default function BetTable({ rows }) {
  // Mock data

  return (
    <StyledTableContainer>
      {rows.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Bettors</TableCell>
              <TableCell>Racer</TableCell>
              <TableCell>Total Bet</TableCell>
              {/* <TableCell>Est Payouts</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <StyledTableRow key={index}>
                <TableCell>
                  <UserCell avatar={row.bettorImage} username={row.bettor} />
                </TableCell>
                <TableCell>
                  <UserCell avatar={row.racerImage} username={row.racer} />
                </TableCell>
                <TableCell>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: fontSizes.heading3,
                    }}
                  >
                    <CurrencyIcon />
                    {row.totalBet}
                  </Box>
                </TableCell>
                {/* <TableCell>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: fontSizes.heading3,
                    }}
                  >
                    <CurrencyIcon />
                    {row.estPayout}
                  </Box>
                </TableCell> */}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography
          sx={{
            textAlign: "center",
            color: "#fff",
            fontSize: fontSizes.heading3,
            py: 2,
          }}
        >
          No bets yet
        </Typography>
      )}
    </StyledTableContainer>
  );
}
